import {Component, Prop, Vue, Watch} from '@/node_modules/nuxt-property-decorator';
import RoutingUtil from "@/classes/view/routing-util";
import APage from '@/classes/page/a-page';
import {appModule} from '@/store/app';
import {Faq} from "@/configs/faq";
import MToggleList from '@/components/module/MToggleList.vue';

@Component({
	layout: 'teaser',
    components: {
        MToggleList,
    }
})
export default class Index extends APage {

	public title: string;

    ///////// 全ページ共通 ////////////////////////////////////////////
    public mypagetype: string = 'official-page';
	public mydivider: string = 'full';


    ///////// このページ ////////////////////////////////////////////
    public faqdata: any = Faq;


    // ヘッダタグの構成要素
    public head() {
        return {
            title: 'よくある質問｜THOUGHT ブランディングツール'
        }
    }

    ///////// 全ページ共通 ////////////////////////////////////////////
    public transition(to: any, from: any) {
		return RoutingUtil.transition(to, from);
	}

    public created(){

		///////// 全ページ共通 ////////////////////////////////////////////
		this.setPagetype( appModule, this.mypagetype, this.mydivider );


        ///////// このページ ////////////////////////////////////////////
    }

//     public mounted() {
//         window!['FONTPLUS'].async();
//         window!['FONTPLUS'].start();
//     }

    ///////// Computed ////////////////////////////////////////////


	public get deviceSize(): any {
    	return appModule.deviceSize;
	}


}




